export const returnAlgLists = (allAlgorithmOnline, saveprocess) => {
    let defaultList = [];
    saveprocess.map((node) => {
        allAlgorithmOnline.map((algorithm) => {
            if (node.dataSource) {
                if (node.dataSource.algoirthmID === algorithm.algoirthmID) {
                    console.log('12.27', node, algorithm)
                    defaultList.push(algorithm);
                }
            } else
                if (node.name === algorithm.chsName) {
                    defaultList.push(algorithm);

                }
        })
    })
    return defaultList;
}

export const returnRelations = (saveprocess, aPamas, outputs) => {
    console.log("saveprocess, aPamas, outputs", saveprocess, aPamas, outputs);
    let list = [];
    let input = {};
    saveprocess.map((node) => {
        if (node.toolId === 0)
            input = node;
    })
    let nowNode = JSON.parse(JSON.stringify(input));
    while (nowNode.targetNodes[0] !== undefined) {
        saveprocess.map((node) => {
            if (node.uuid === nowNode.targetNodes[0]) {
                list.push(nowNode);
                nowNode = node;
            }
        })
    }
    list.push(nowNode);
    console.log("list", list);
    let relations = [];
    list.map((node, index) => {
        if (index >= list.length - 1)
            return;
        let data = {
            // "algName": node.name,
            // "dependAlg": list[index + 1].name,
            "algName": list[index + 1].name,
            "dependAlg": node.name,
            "relationPairs": []
        };
        if (index === 0) {
            let relationPairs = [];
            aPamas.map((parms) => {
                relationPairs.push({
                    "inputName": parms.paraName,
                    "outPutName": parms.paraName
                })
            })
            data.relationPairs = [...relationPairs];
        } else if (index === 1) {
            let relationPairs = [];
            outputs.map((parms) => {
                relationPairs.push({
                    "inputName": parms.paraName,
                    "outPutName": parms.paraName
                })
            })
            data.relationPairs = [...relationPairs];
        }
        relations.push(data);
    });
    return relations;
}
export const returnRelations_New = (saveprocess) => {
    console.log("returnRelations_New", saveprocess,);
    let list = [];
    let input = {};
    saveprocess.map((node) => {
        if (node.toolId === 0)
            input = node;
    })
    let nowNode = JSON.parse(JSON.stringify(input));
    while (nowNode.targetNodes[0] !== undefined) {
        saveprocess.map((node) => {
            if (node.uuid === nowNode.targetNodes[0]) {
                list.push(nowNode);
                nowNode = node;
            }
        })
    }
    list.push(nowNode);
    console.log("list", list);
    let relations = [];
    let preAlgRelationPairs = [];
    list.map((preNode, index) => {
        console.log('ceshi', preNode)
        if (index >= list.length - 1)
            return;
        let node = list[index + 1];
        let data
        if (index === 0) {
            data = {//preNode为Inputs
                // "algName": node.name,
                // "dependAlg": list[index + 1].name,
                "algName": node.dataSource.algorithmName,
                "dependAlg": preNode.name,
                "relationPairs": []
            };
        } else if (index === list.length - 2) {
            data = {//node为Outputs
                // "algName": node.name,
                // "dependAlg": list[index + 1].name,
                "algName": node.name,
                "dependAlg": preNode.dataSource.algorithmName,
                "relationPairs": []
            };
        } else {
            data = {//node为Outputs
                // "algName": node.name,
                // "dependAlg": list[index + 1].name,
                "algName": node.dataSource.algorithmName,
                "dependAlg": preNode.dataSource.algorithmName,
                "relationPairs": []
            };
        }

        if (node.dataSource && node.dataSource.aPamas) {
            let relationPairs = [];
            node.dataSource.aPamas.map((parms, index) => {
                if (parms.control !== 'File') return;
                if (!preAlgRelationPairs[index]) {
                    relationPairs.push({
                        "inputName": parms.paraName,
                        "outPutName": parms.paraName
                    })
                }
                else {
                    relationPairs.push({
                        "inputName": parms.paraName,
                        "outPutName": preNode.dataSource.outputs[0].paraName
                    })
                }
            })
            preAlgRelationPairs = [...relationPairs];
            data.relationPairs = [...relationPairs];
        }
        else if (index + 1 === list.length - 1) {
            let relationPairs = [];
            preNode.dataSource.outputs.map((parms, index) => {
                // if (parms.paraType !== 'Tile' && parms.paraType !== 'File' && parms.paraType !== 'file') return;
                relationPairs.push({
                    "inputName": parms.paraName,
                    "outPutName": parms.paraName
                })
            })
            data.relationPairs = [...relationPairs];
        }
        relations.push(data);
    });
    return relations;
}

export const returnWorkflowSave = (propsThis, algLists, saveprocess) => {
    let state = propsThis.state;
    let props = propsThis.props;
    let afterInput = {};
    let beforeOutput = {};
    let input = "";
    let output = "";
    console.log("returnWorkflowSave", algLists, saveprocess);
    saveprocess.map((node) => {
        if (node.toolId === 0)
            input = node.targetNodes[0];
        if (node.toolId === 1)
            output = node.uuid;
    })
    saveprocess.map((node) => {
        if (node.uuid === input)
            input = node.name;
        if (node.targetNodes[0] === output)
            output = node.name;
    })
    state.allAlgorithmOnline.map((algorithm) => {
        if (input === algorithm.chsName)
            afterInput = algorithm;
        if (output === algorithm.chsName)
            beforeOutput = algorithm;
    })

    let defaultList = {
        // "content": [
        //     ...saveprocess
        // ],
        "userid": props.user.userId,
        "username": props.user.userName,
        "workflowSave": {
            "algCompt": [
                ...algLists
            ],
            "author": state.author,
            "calPamas": [       //input
                ...afterInput.calPamas
            ],
            "flowChsName": state.flowChsName,       //flowName
            "flowName": state.flowEngName,
            "flowDesc": state.flowDesc,
            // "flowID": "string",
            "flowLevel": state.flowLevel,
            "flowType": state.flowType,
            "flowVersion": state.flowVersion,
            "inputs": [         //input
                ...afterInput.aPamas
            ],
            "outputs": [        //output
                ...beforeOutput.outputs
            ],
            "proChsName": state.proChsName,
            "proClass": state.proClass,
            "proDesc": state.proDesc,
            "proLevel": state.proLevel,
            "proName": state.proName,
            "proVersion": state.proVersion,
            "relations": [
                // ...returnRelations(saveprocess, afterInput.aPamas, beforeOutput.outputs)
                ...returnRelations_New(saveprocess)
            ],
            "utility": [
                ...afterInput.utilities
            ]
        }
    }
    console.log("tools----------------------", state.nowClickMyWorkflowPro && state.nowClickMyWorkflowPro.flowID, state.nowClickMyWorkflowPro);
    if (state.nowClickMyWorkflowPro && state.nowClickMyWorkflowPro.flowID && state.select !== 1) {
        // defaultList.workflowSave.flowID=state.nowClickMyWorkflowPro.flowID;
        defaultList.flowId = state.nowClickMyWorkflowPro.flowID;
    }
    return defaultList;
}

export const returnAlgorithmTools = (dataSource) => {
    // let algorithmTools = [];
    // let commonList = {
    //     typeName: "通用组件",
    //     compontentList: [
    //         { name: 'Inputs', type: 'common', toolId: 0, description: "数据源" },
    //         { name: 'Outputs', type: 'common', toolId: 1, description: "终止", },
    //     ]
    // };
    // algorithmTools.push(commonList);


    let tools = [];
    dataSource.map((allAlgorithm, index) => {
        let temp = { name: allAlgorithm.chsName, type: "level3", toolId: index + 2, dataSource: allAlgorithm };
        tools.push(temp);
    });


    let algorithmTools = [];
    tools.map((tool, index) => {
        let className = tool.dataSource.algorithmClass.split("_")[0];
        let type = tool.dataSource.algorithmClass.split("_")[1];
        let classIndex = algorithmTools.findIndex((a) => a.className === className);
        // console.log("algorithmTools",algorithmTools,classIndex);
        if (classIndex === -1) {
            let newClass = {
                className: className,
                typeList: [
                    {
                        typeName: type,
                        compontentList: [
                            // { name: tool.name, type: type, toolId: tool.toolId, dataSource: tool.dataSource},    
                            { name: tool.name, type: type, toolId: tool.toolId, dataSource: tool.dataSource },   //或许没必要传得那么复杂
                        ]
                    }
                ]
            };
            algorithmTools.push(newClass);
        }
        else {
            // debugger
            let classList = algorithmTools[classIndex].typeList;
            let typeIndex = classList.findIndex((a) => a.typeName === type);
            if (typeIndex === -1) {
                let newType = {
                    typeName: type,
                    compontentList: [
                        { name: tool.name, type: type, toolId: tool.toolId, dataSource: tool.dataSource },
                    ]
                };
                classList.push(newType);
            }
            else {
                let typeList = classList[typeIndex];
                typeList.compontentList.push({ name: tool.name, type: type, toolId: tool.toolId, dataSource: tool.dataSource });
                classList[typeIndex] = typeList;
            }
            algorithmTools[classIndex].typeList = classList;
        }
    })

    let count = 0
    algorithmTools.map(tool => {
        count = 0
        tool.typeList.forEach(type => {
            count += type.compontentList.length
        })
        tool.count = count
        return tool
    })
    return algorithmTools;
}

export const returnTipTools = (dataSource) => {
    let tools = [];
    dataSource.map((allAlgorithm, index) => {
        if (allAlgorithm.type === 'common') {
            tools.push(allAlgorithm);
        } else {
            let temp = { name: allAlgorithm.chsName, type: "level3", toolId: index + 2, dataSource: allAlgorithm };
            tools.push(temp);
        }
    });
    return tools
}


export const returnQueryByProcessDesign = (algId, algName, dependAlg, mxPoints, mxRelations, userid, username, x, y) => {
    let query = "?";
    let queryFlag = true;
    if (algId !== "") {
        query += "algId=" + algId;
        queryFlag = false;
    }

    if (queryFlag && algName !== "") {
        query += "algName=" + algName;
        queryFlag = false;
    }
    else if (algName !== "") {
        query += "&algName=" + algName;
    }

    if (queryFlag && dependAlg !== "") {
        query += "dependAlg=" + dependAlg;
        queryFlag = false;
    }
    else if (dependAlg !== "") {
        query += "&dependAlg=" + dependAlg;
    }

    if (queryFlag && mxPoints[0].algId !== "") {
        query += "mxPoints[0].algId=" + mxPoints[0].algId;
        queryFlag = false;
    }
    else if (mxPoints[0].algId !== "") {
        query += "&mxPoints[0].algId=" + mxPoints[0].algId;
    }

    if (queryFlag && mxPoints[0].x !== "") {
        query += "mxPoints[0].x=" + mxPoints[0].x;
        queryFlag = false;
    }
    else if (mxPoints[0].x !== "") {
        query += "&mxPoints[0].x=" + mxPoints[0].x;
    }

    if (queryFlag && mxPoints[0].y !== "") {
        query += "mxPoints[0].y=" + mxPoints[0].y;
        queryFlag = false;
    }
    else if (mxPoints[0].y !== "") {
        query += "&mxPoints[0].y=" + mxPoints[0].y;
    }

    if (queryFlag && mxRelations[0].algName !== "") {
        query += "mxRelations[0].algName=" + mxRelations[0].algName;
        queryFlag = false;
    }
    else if (mxRelations[0].algName !== "") {
        query += "&mxRelations[0].algName=" + mxRelations[0].algName;
    }

    if (queryFlag && mxRelations[0].dependAlg !== "") {
        query += "mxRelations[0].dependAlg=" + mxRelations[0].dependAlg;
        queryFlag = false;
    }
    else if (mxRelations[0].dependAlg !== "") {
        query += "&mxRelations[0].dependAlg=" + mxRelations[0].dependAlg;
    }

    if (queryFlag && userid !== "") {
        query += "userid=" + userid;
        queryFlag = false;
    }
    else if (userid !== "") {
        query += "&userid=" + userid;
    }

    if (queryFlag && username !== "") {
        query += "username=" + username;
        queryFlag = false;
    }
    else if (username !== "") {
        query += "&username=" + username;
    }

    if (queryFlag && x !== "") {
        query += "x=" + x;
        queryFlag = false;
    }
    else if (x !== "") {
        query += "&x=" + x;
    }

    if (queryFlag && y !== "") {
        query += "y=" + y;
        queryFlag = false;
    }
    else if (y !== "") {
        query += "&y=" + y;
    }

    return query;
}


/**
 * 算法工具
 * @type {[{toolId: number, name: string, description: string, type: string}, {toolId: number, name: string, description: string, type: string}, {toolId: number, name: string, type: string}, {toolId: number, name: string, type: string}, {toolId: number, name: string, type: string}, null, null, null, null, null, null, null, null, null, null]}
 */
const defaulttools = [
    { name: 'Inputs', type: 'common', toolId: 0, description: "数据源" },
    { name: 'Outputs', type: 'common', toolId: 1, description: "终止", },

    { name: "水体透明度产品算法", type: "level3", toolId: 2 },
    { name: "光合有效辐射吸收比率", type: "level3", toolId: 3 },
    { name: "几何校正", type: "level3", toolId: 4 },
    { name: "瓦片切分程序", type: "level3", toolId: 5 },
    { name: "光学土壤含水量", type: "level3", toolId: 6 },
    { name: "PM10产品算法", type: "level3", toolId: 7 },
    { name: "地表反射率产品", type: "level3", toolId: 8 },
    { name: "加", type: "level3", toolId: 9 },
    { name: "均值滤波", type: "level3", toolId: 10 },
    { name: "小于", type: "level3", toolId: 11 },
    { name: "大于", type: "level3", toolId: 12 },
    { name: "大气校正", type: "level3", toolId: 13 },
    { name: "影像地图产品", type: "level3", toolId: 14 },
    { name: "海洋水色高精度快速反演", type: "level3", toolId: 15 },
    { name: "云量检测", type: "level3", toolId: 16 },
    { name: "地表温度专题产品", type: "level3", toolId: 17 },
    { name: "非", type: "level3", toolId: 18 },
    { name: "直方图增强", type: "level3", toolId: 19 },
    { name: "亮温专题产品", type: "level3", toolId: 20 },
    { name: "方向滤波", type: "level3", toolId: 21 },
    { name: "中值滤波", type: "level3", toolId: 22 },
    { name: "人机交互程序", type: "level3", toolId: 23 },
    { name: "傅里叶变换", type: "level3", toolId: 24 },
    { name: "离水反射率", type: "level3", toolId: 25 },
    { name: "辐亮度产品算法", type: "level3", toolId: 26 },
    { name: "坡度计算", type: "level3", toolId: 27 },
    { name: "统计滤波", type: "level3", toolId: 28 },
    { name: "坡向计算", type: "level3", toolId: 29 },
    { name: "植被指数计算", type: "level3", toolId: 30 },
    { name: "植被覆盖度计算", type: "level3", toolId: 31 },
    { name: "二值开运算", type: "level3", toolId: 32 },
    { name: "二值闭运算", type: "level3", toolId: 33 },
    { name: "灰度开运算", type: "level3", toolId: 34 },
    { name: "二值腐蚀", type: "level3", toolId: 35 },
    { name: "形态学滤波", type: "level3", toolId: 36 },
    { name: "灰度腐蚀", type: "level3", toolId: 37 },
    { name: "二值膨胀", type: "level3", toolId: 38 },
    { name: "灰度膨胀", type: "level3", toolId: 39 },
    { name: "云覆盖", type: "level3", toolId: 40 },
    { name: "阴影去除", type: "level3", toolId: 41 },
    { name: "气溶胶反演专题产品", type: "level3", toolId: 42 },
    { name: "气溶胶专题产品", type: "level3", toolId: 43 },
    { name: "面向对象分类", type: "level3", toolId: 44 },
    { name: "地表粗分类", type: "level3", toolId: 45 },
    { name: "内陆水体参量高精度反演", type: "level3", toolId: 46 },
    { name: "PCA变换", type: "level3", toolId: 47 },
    { name: "光学厚度", type: "level3", toolId: 48 },
    { name: "薄云去除", type: "level3", toolId: 49 },
    { name: "自定义模板滤波", type: "level3", toolId: 50 },
    { name: "HIS变换", type: "level3", toolId: 51 },
    { name: "小波变换", type: "level3", toolId: 52 },
    { name: "地物目标精细识别", type: "level3", toolId: 53 },
    { name: "悬浮物浓度专题产品", type: "level3", toolId: 54 },
    { name: "叶绿素a浓度专题产品", type: "level3", toolId: 55 },
    { name: "叶面积指数专题", type: "level3", toolId: 56 },
    { name: "同态滤波", type: "level3", toolId: 57 },
    { name: "格式转换", type: "level3", toolId: 58 },
    { name: "叶面积指数反演", type: "level3", toolId: 59 },
    { name: "影像表观反射率", type: "level3", toolId: 60 },
    { name: "投影变换", type: "level3", toolId: 61 },
    { name: "除", type: "level3", toolId: 62 },
    { name: "乘", type: "level3", toolId: 63 },
    { name: "图像拼接", type: "level3", toolId: 64 },
    { name: "与", type: "level3", toolId: 65 },
    { name: "图像融合", type: "level3", toolId: 66 },
    { name: "或", type: "level3", toolId: 67 },
    { name: "减", type: "level3", toolId: 68 },
    { name: "异或", type: "level3", toolId: 69 },
    { name: "变化检测专题产品", type: "level3", toolId: 70 },

    { name: "1米C-SAR卫星正射", type: "level4", toolId: 71 },
    { name: "3米L-SAR卫星正射校正", type: "level4", toolId: 72 },
    { name: "5米S-SAR卫星正射校正", type: "level4", toolId: 73 },
    { name: "高轨20米SAR卫星正射校正", type: "level4", toolId: 74 },
    { name: "1米C-SAR卫星高程", type: "level4", toolId: 75 },
    { name: "3米L-SAR卫星高程", type: "level4", toolId: 76 },
    { name: "5米S-SAR卫星高程", type: "level4", toolId: 77 },
    { name: "高轨20米SAR卫星高程", type: "level4", toolId: 78 },
    { name: "1米C-SAR卫星后向散射系数", type: "level4", toolId: 79 },
    { name: "3米L-SAR卫星后向散射系数", type: "level4", toolId: 80 },
    { name: "5米S-SAR卫星后向散射系数", type: "level4", toolId: 81 },
    { name: "高轨20米SAR卫星后向散射系数", type: "level4", toolId: 82 },
    { name: "1米C-SAR卫星干涉测量相位大气延迟校正", type: "level4", toolId: 83 },
    { name: "3米L-SAR卫星干涉测量相位大气延迟校正", type: "level4", toolId: 84 },
    { name: "5米S-SAR卫星干涉测量相位大气延迟校正", type: "level4", toolId: 85 },
    { name: "高轨20米SAR卫星干涉测量相位大气延迟校正", type: "level4", toolId: 86 },
    { name: "1米C-SAR卫星干涉测量形变", type: "level4", toolId: 87 },
    { name: "3米L-SAR卫星干涉测量形变", type: "level4", toolId: 88 },
    { name: "5米S-SAR卫星干涉测量形变", type: "level4", toolId: 89 },
    { name: "高轨20米SAR卫星干涉测量形变", type: "level4", toolId: 90 },
    { name: "1米C-SAR卫星地表覆盖类型", type: "level4", toolId: 91 },
    { name: "3米L-SAR卫星地表覆盖类型", type: "level4", toolId: 92 },
    { name: "5米S-SAR卫星地表覆盖类型", type: "level4", toolId: 93 },
    { name: "高轨20米SAR卫星地表覆盖类型", type: "level4", toolId: 94 },
    { name: "1米C-SAR卫星土壤水分", type: "level4", toolId: 95 },
    { name: "3米L-SAR卫星土壤水分", type: "level4", toolId: 96 },
    { name: "5米S-SAR卫星土壤水分", type: "level4", toolId: 97 },
    { name: "高轨20米SAR卫星土壤水分", type: "level4", toolId: 98 },
    { name: "1米C-SAR卫星土壤盐碱度", type: "level4", toolId: 99 },
    { name: "3米L-SAR卫星土壤盐碱度", type: "level4", toolId: 100 },
    { name: "1米C-SAR卫星地表粗糙度", type: "level4", toolId: 101 },
    { name: "3米L-SAR卫星地表粗糙度", type: "level4", toolId: 102 },
    { name: "1米C-SAR卫星植被物候", type: "level4", toolId: 103 },
    { name: "3米L-SAR卫星植被物候", type: "level4", toolId: 104 },
    { name: "1米C-SAR卫星叶面积指数", type: "level4", toolId: 105 },
    { name: "3米L-SAR卫星叶面积指数", type: "level4", toolId: 106 },
    { name: "5米S-SAR卫星叶面积指数", type: "level4", toolId: 107 },
    { name: "高轨20米SAR卫星叶面积指数", type: "level4", toolId: 108 },
    { name: "3米L-SAR卫星植被高度", type: "level4", toolId: 109 },
];

/**
 * 我的流程
 * @type {[{name: string, content: [{toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: *[]}]}, {name: string, content: [{toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: *[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, type: string, uuid: string, targetNodes: string[]}]}, {name: string, content: [{toolId: number, deleted: boolean, top: string, left: string, name: string, id: string, type: string, uuid: string, targetNodes: *[]}, {toolId: number, deleted: boolean, top: string, left: string, name: string, id: string, type: string, uuid: string, targetNodes: *[]}]}, {}, {}, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]}
 */
const defaultpro = [
    {
        name: '我的流程1',
        content: [
            {
                "deleted": false,
                "targetNodes": ["node-7-1612663807696"],
                "toolId": 3,
                "left": "248px", "top": "224px",
                "uuid": "node-3-1612663806580",
                "name": "影像表现反射库",
                "type": "level3"
            },
            {
                "deleted": false,
                "targetNodes": ["node-3-1612663808568"],
                "toolId": 7, "left": "472px", "top": "224px",
                "uuid": "node-7-1612663807696",
                "name": "云覆盖", "type": "level3"
            },
            {
                "deleted": false,
                "targetNodes": ["node-1-1612663812504"],
                "toolId": 3, "left": "716px", "top": "225px",
                "uuid": "node-3-1612663808568",
                "name": "影像表现反射库", "type": "level3"
            },
            {
                "deleted": false, "targetNodes": ["node-3-1612663806580"],
                "toolId": 0, "left": "339px", "top": "20px",
                "uuid": "node-0-1612663811276",
                "name": "Inputs", "type": "common"
            },
            {
                "deleted": false, "targetNodes": [],
                "toolId": 1, "left": "611px", "top": "553px",
                "uuid": "node-1-1612663812504",
                "name": "Outputs", "type": "common"
            }
        ],
    },
    {
        name: '我的流程2',
        content: [
            {
                "deleted": false,
                "targetNodes": ["node-4-1612505841827", "node-4-1612505841827", "node-4-1612505841827", "node-4-1612505841827"],
                "toolId": 0,
                "left": "195px",
                "top": "194px",
                "uuid": "node-0-1612505838798",
                "name": "Inputs",
                "type": "common"
            },
            {
                "deleted": false,
                "targetNodes": [],
                "toolId": 1,
                "left": "781px",
                "top": "647px",
                "uuid": "node-1-1612505839609",
                "name": "Outputs",
                "type": "common"
            },
            {
                "deleted": false,
                "targetNodes": ["node-3-1612505842623", "node-3-1612505842623", "node-4-1612513341439", "node-3-1612505842623", "node-3-1612505842623", "node-4-1612513341439"],
                "toolId": 4,
                "left": "526px",
                "top": "126px",
                "uuid": "node-4-1612505841827",
                "name": "滤值均波",
                "type": "level3"
            },
            {
                "deleted": false,
                "targetNodes": ["node-1-1612505839609", "node-1-1612505839609", "node-1-1612505839609", "node-1-1612505839609"],
                "toolId": 3,
                "left": "495px",
                "top": "408px",
                "uuid": "node-3-1612505842623",
                "name": "影像表现反射库",
                "type": "level3"
            },
            {
                "deleted": false,
                "targetNodes": ["node-1-1612505839609", "node-1-1612505839609"],
                "toolId": 4,
                "left": "910px",
                "top": "320px",
                "uuid": "node-4-1612513341439",
                "name": "滤值均波",
                "type": "level3"
            }
        ]
    },
    {
        name: '我的流程3',
        content: [
            {
                "deleted": false,
                "targetNodes": [],
                "toolId": 0,
                "left": "119px",
                "top": "246px",
                "uuid": "node-0-1612677232310",
                "name": "Inputs",
                "type": "common",
                "id": "node-0-1612677232310-1612677232310"
            },
            {
                "deleted": false,
                "targetNodes": [],
                "toolId": 1,
                "left": "365px",
                "top": "240px",
                "uuid": "node-1-1612677233441",
                "name": "Outputs",
                "type": "common",
                "id": "node-1-1612677233441-1612677233441"
            }
        ]
    },
    { name: "123", content: [{ "deleted": false, "targetNodes": ["node-1-1663231881459"], "toolId": 3, "left": "1513px", "top": "1184px", "uuid": "node-3-1663231869455", "name": "光合有效辐射吸收比率", "type": "level3", "id": "node-3-1663231869455" }, { "deleted": false, "targetNodes": ["node-3-1663231869455"], "toolId": 2, "left": "1296px", "top": "1170px", "uuid": "node-2-1663231876202", "name": "水体透明度产品算法", "type": "level3", "id": "node-2-1663231876202" }, { "deleted": false, "targetNodes": ["node-2-1663231876202"], "toolId": 0, "left": "1019px", "top": "1187px", "uuid": "node-0-1663231880259", "name": "Inputs", "type": "common", "id": "node-0-1663231880259" }, { "deleted": false, "targetNodes": [], "toolId": 1, "left": "1748px", "top": "1199px", "uuid": "node-1-1663231881459", "name": "Outputs", "type": "common", "id": "node-1-1663231881459" }] },
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {},
    // {}
];